import React, { useEffect, useState } from 'react';
import { useStores } from "../../../stores/Context";
import ParametreSvg from "../../../boiteAOutils/SVG/ParametreSvg";
import FlecheRevenirSvg from "../../../boiteAOutils/SVG/FlecheRevenirSvg";
import FlecheCercleSvg from "../../../boiteAOutils/SVG/FlecheCercleSvg";
import { autorun, action } from "mobx";
import { observer } from "mobx-react";
import { useParams } from "react-router-dom";
import ModalPrimary from "../../../boiteAOutils/ModalPrimary";

// Vues "principales" où la sidebar complète est visible
const MAIN_VIEWS = ['Lecture', 'Kanban', 'Calendrier', 'Tableau', 'Jour', 'Semaine', 'Mois'];
// Vues "secondaires" où on affiche seulement "Revenir"
const SECONDARY_VIEWS = ['Paramétrage', 'Paramétrage colonnes / lignes'];

const WidgetPlanningActionsBtn = () => {
    const { ent } = useParams();
    const { PlanningActionsStore, uiStore, widgetStore } = useStores();
    const [nbActionsRecues, setNbActionsRecues] = useState(PlanningActionsStore.intertotemActionsReceived.length);
    const [showModal, setShowModal] = React.useState(false);

    const cookieEntreprise = widgetStore.getCookie("currentEntrepriseInfos");
    const entrepriseInfos = (() => {
        if (!cookieEntreprise) return {};
        try { return JSON.parse(cookieEntreprise); } catch (_) {
            try { return JSON.parse(decodeURIComponent(cookieEntreprise)); } catch (__) { return {}; }
        }
    })();

    const setNbActionsRecuesAction = action((value) => {
        setNbActionsRecues(value);
    });

    useEffect(() => {
        const disposer = autorun(() => {
            setNbActionsRecuesAction(PlanningActionsStore.intertotemActionsReceived.length);
        });
        return () => disposer();
    }, [PlanningActionsStore]);

    const currentView = PlanningActionsStore.view;
    const isMainView = MAIN_VIEWS.includes(currentView);
    const isSecondaryView = SECONDARY_VIEWS.includes(currentView);

    const handleGoHome = (e) => {
        e.preventDefault();
        uiStore.closeConsultingIndicateurWidget();
    };

    const handleBtnAddAction = () => {
        PlanningActionsStore.recupTaches().then(() => {
            if (PlanningActionsStore.taches.length >= 5 && entrepriseInfos.subscriber === false) {
                setShowModal(true);
                return;
            }
            PlanningActionsStore.openModalFormAction(null, null, null, null);
        });
    };

    const handleBtnView = (view) => {
        PlanningActionsStore.changeView(view);
    };

    const isViewActive = (view) => {
        if (view === 'Kanban') return currentView === 'Kanban' || currentView === 'Lecture';
        if (view === 'Calendrier') return ['Calendrier', 'Jour', 'Semaine', 'Mois'].includes(currentView);
        return currentView === view;
    };

    return (
        <div className={"navBarWidgetBtnContent"}>

            {/* ── Vue secondaire (Paramétrage) : juste "Revenir" ─────────── */}
            {isSecondaryView && (
                <div className={"widgetsNavBarContentIcons"} onClick={() => handleBtnView("Kanban")}>
                    <svg style={{ width: "3em" }} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.69144 31.0563C1.86301 31.0563 1.19144 31.7278 1.19144 32.5563C1.19144 33.3847 1.86301 34.0563 2.69144 34.0563V31.0563ZM7.79717 12.9393C7.21138 13.5251 7.21138 14.4749 7.79717 15.0607L17.3431 24.6066C17.9289 25.1924 18.8786 25.1924 19.4644 24.6066C20.0502 24.0208 20.0502 23.0711 19.4644 22.4853L10.9791 14L19.4644 5.51472C20.0502 4.92893 20.0502 3.97919 19.4644 3.3934C18.8786 2.80761 17.9289 2.80761 17.3431 3.3934L7.79717 12.9393ZM2.69144 34.0563H27.5704V31.0563H2.69144V34.0563ZM27.5704 34.0563C33.46 34.0563 38.1914 29.2061 38.1914 23.2781H35.1914C35.1914 27.5978 31.755 31.0563 27.5704 31.0563V34.0563ZM38.1914 23.2781C38.1914 17.3501 33.46 12.5 27.5704 12.5V15.5C31.755 15.5 35.1914 18.9584 35.1914 23.2781H38.1914ZM27.5704 12.5H8.85783V15.5H27.5704V12.5Z"
                            fill="#FBFDFE" />
                    </svg>
                    <span className={"widgetsNavBarContentIconsText"}>Revenir</span>
                </div>
            )}

            {/* ── Vues principales : sidebar complète ─────────────────────── */}
            {isMainView && (
                <>
                    {/* Revenir au dashboard */}
                    <div className={"widgetsNavBarContentIcons"} onClick={handleGoHome}>
                        <FlecheRevenirSvg width={40} height={40} couleur={"#FBFDFE"} />
                        <span className={"widgetsNavBarContentIconsText"}>Revenir</span>
                    </div>

                    {/* Nouvelle tâche */}
                    <div className={"widgetsNavBarContentIcons"} onClick={handleBtnAddAction}>
                        <div className={"navBarWidgetBtnAdd"}>
                            <svg width="40" height="39" viewBox="0 0 40 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 4.875V34.125" stroke="white" strokeWidth="4" />
                                <path d="M5.37598 19.5H34.6245" stroke="white" strokeWidth="4" />
                            </svg>
                        </div>
                    </div>

                    {/* Point d'entrée unique : les actions reçues et envoyées sont suivies ici. */}
                    <div className={"widgetsNavBarContentIcons"} onClick={() => PlanningActionsStore.openIntertotemActions()}>
                        <svg style={{ width: '2.2em' }} viewBox="0 0 24 24" fill="none" stroke="#FBFDFE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M7 7h11l-3-3" /><path d="M18 7l-3 3" /><path d="M17 17H6l3 3" /><path d="M6 17l3-3" />
                        </svg>
                        <span className={"widgetsNavBarContentIconsText"}>Actions échangées</span>
                        {nbActionsRecues > 0 && (
                            <span className={"notificationBadge"}>{nbActionsRecues}</span>
                        )}
                    </div>

                    {/* Kanban */}
                    <div
                        className={`widgetsNavBarContentIcons${isViewActive('Kanban') ? ' active' : ''}`}
                        onClick={() => handleBtnView("Kanban")}
                    >
                        <svg style={{ width: "2.2em" }} viewBox="0 0 24 24" fill="none" stroke="#FBFDFE" strokeWidth="2" strokeLinecap="round">
                            <rect x="3" y="3" width="7" height="18" rx="1" />
                            <rect x="14" y="3" width="7" height="11" rx="1" />
                        </svg>
                        <span className={"widgetsNavBarContentIconsText"}>Kanban</span>
                    </div>

                    {/* Calendrier */}
                    <div
                        className={`widgetsNavBarContentIcons${isViewActive('Calendrier') ? ' active' : ''}`}
                        onClick={() => handleBtnView("Calendrier")}
                    >
                        <svg style={{ width: "2.2em" }} viewBox="0 0 24 24" fill="none" stroke="#FBFDFE" strokeWidth="2" strokeLinecap="round">
                            <rect x="3" y="4" width="18" height="18" rx="2" />
                            <line x1="16" y1="2" x2="16" y2="6" />
                            <line x1="8" y1="2" x2="8" y2="6" />
                            <line x1="3" y1="10" x2="21" y2="10" />
                        </svg>
                        <span className={"widgetsNavBarContentIconsText"}>Calendrier</span>
                    </div>

                    {/* Tableau */}
                    <div
                        className={`widgetsNavBarContentIcons${isViewActive('Tableau') ? ' active' : ''}`}
                        onClick={() => handleBtnView("Tableau")}
                    >
                        <svg style={{ width: "2.2em" }} viewBox="0 0 24 24" fill="none" stroke="#FBFDFE" strokeWidth="2" strokeLinecap="round">
                            <rect x="3" y="3" width="18" height="18" rx="2" />
                            <line x1="3" y1="9" x2="21" y2="9" />
                            <line x1="3" y1="15" x2="21" y2="15" />
                            <line x1="9" y1="9" x2="9" y2="21" />
                        </svg>
                        <span className={"widgetsNavBarContentIconsText"}>Tableau</span>
                    </div>

                    {/* Paramètres */}
                    <div className={"widgetsNavBarContentIcons"} onClick={() => handleBtnView("Paramétrage")}>
                        <ParametreSvg width={36} height={39} couleur={"#FBFDFE"} />
                        <span className={"widgetsNavBarContentIconsText"}>Paramètres</span>
                    </div>
                    {/* Archives */}
                    <div className={"widgetsNavBarContentIcons"} onClick={() => PlanningActionsStore.openModal('archive')}>
                        <FlecheCercleSvg width={40} height={40} couleur={"#FBFDFE"} />
                        <span className={"widgetsNavBarContentIconsText"}>Archives</span>
                    </div>
                </>
            )}

            {showModal && (
                <ModalPrimary
                    textTitle="Limite atteinte"
                    textComment="Vous avez atteint la limite de 5 actions. Passez à l'abonnement pour en ajouter davantage."
                    textBtnValidate="OK"
                    textBtnCancel="Annuler"
                    onCancel={() => setShowModal(false)}
                    textURL="S'abonner"
                    URL="https://www.seizo.fr/pricing-plans/list"
                />
            )}
        </div>
    );
};

export default observer(WidgetPlanningActionsBtn);
